import { render, staticRenderFns } from "./leftType.vue?vue&type=template&id=3e91fc1f&scoped=true&"
import script from "./leftType.vue?vue&type=script&lang=js&"
export * from "./leftType.vue?vue&type=script&lang=js&"
import style0 from "./leftType.vue?vue&type=style&index=0&id=3e91fc1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91fc1f",
  null
  
)

export default component.exports